import { render } from "./EditGeneral.vue?vue&type=template&id=e6539700"
import script from "./EditGeneral.vue?vue&type=script&lang=js"
export * from "./EditGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__